// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".templateMessage__isLastInStreak___3kdcr{margin-bottom:10px}.templateMessage__kbArticlesChatBubble___CJCqB{padding:0;display:flex;flex-direction:column;width:250px;background-color:#fff !important}.templateMessage__kbArticle___8uUw_{display:flex;align-items:center;cursor:pointer;padding:10px;border-bottom:.5px solid #e9eff5}.templateMessage__kbArticle___8uUw_:hover{background-color:#f3f5f8}.templateMessage__articleDetails___3K2uu{flex-grow:1;overflow:hidden}.templateMessage__articleTitle___2Mlw9{color:var(--primary-button-background-color);text-overflow:ellipsis;white-space:nowrap;overflow:hidden}@supports(-webkit-line-clamp: 2){.templateMessage__articleTitle___2Mlw9{white-space:initial;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}}.templateMessage__articleDescription___1bLSO{color:#717070;font-size:12px;text-overflow:ellipsis;white-space:nowrap}.templateMessage__articleIcon___1a9dX{color:#717070;display:flex;align-items:center;margin:0 10px 0 0;flex-shrink:0}.templateMessage__chevronRight___2igz9{color:#717070;flex-shrink:0}html[dir=\"rtl\"] .templateMessage__articleIcon___1a9dX{margin:0 0 0 10px}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"isLastInStreak": "templateMessage__isLastInStreak___3kdcr",
	"kbArticlesChatBubble": "templateMessage__kbArticlesChatBubble___CJCqB",
	"kbArticle": "templateMessage__kbArticle___8uUw_",
	"articleDetails": "templateMessage__articleDetails___3K2uu",
	"articleTitle": "templateMessage__articleTitle___2Mlw9",
	"articleDescription": "templateMessage__articleDescription___1bLSO",
	"articleIcon": "templateMessage__articleIcon___1a9dX",
	"chevronRight": "templateMessage__chevronRight___2igz9"
};
module.exports = exports;
